import { render, staticRenderFns } from "./platformSettlementFundDetail.vue?vue&type=template&id=406bf5c0&scoped=true"
import script from "./platformSettlementFundDetail.vue?vue&type=script&lang=js"
export * from "./platformSettlementFundDetail.vue?vue&type=script&lang=js"
import style0 from "./platformSettlementFundDetail.vue?vue&type=style&index=0&id=406bf5c0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406bf5c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('406bf5c0')) {
      api.createRecord('406bf5c0', component.options)
    } else {
      api.reload('406bf5c0', component.options)
    }
    module.hot.accept("./platformSettlementFundDetail.vue?vue&type=template&id=406bf5c0&scoped=true", function () {
      api.rerender('406bf5c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/settlementFund/platformSettlementFundDetail.vue"
export default component.exports